import Vue from 'vue'
import Router from 'vue-router'
import { routes } from '../app'
import store from '../store'
Vue.use(Router)

const router = new Router({
  mode: 'hash',
  routes: routes
})
const originalPush = router.push
Router.prototype.push = function push(location, onResolve, onReject) {
  if (onResolve || onReject) return originalPush.call(this, location, onResolve, onReject)
  return originalPush.call(this, location).catch(err => err)
}

const unRestrictedRoutes = ['login', 'signup', 'verify', 'terms', 'resend', 'unsubscribe']
const authorizedRoutes = ['userSummary']
const subscriptionRoutes = ['orderconfirmed', 'managesubscription', 'modifysubscription', 'cancelsubscription']
const surveyRoutes = ['survey', 'biometrics']
const profileRoutes = ['accountManagement']
const adminAuthorizedRoutes = ['dietitianManagement', 'dietitianClients']

router.beforeEach(async (to, from, next) => {
  const showSpinner = !(to.name === 'messages' && from.name === 'messageThread')
  if (to.name !== from.name && showSpinner) {
    store.dispatch('toggleSpinner', true)
  }
  const restrictedRoute = (unRestrictedRoutes.indexOf(to.name) === -1)
  const authorizedRoute = (authorizedRoutes.indexOf(to.name) !== -1)
  const subscriptionRoute = subscriptionRoutes.includes(to.name)
  const surveyRoute = (surveyRoutes.indexOf(to.name) !== -1)
  const profileRoute = (profileRoutes.indexOf(to.name) !== -1)
  const adminAuthorizedRoute = adminAuthorizedRoutes.includes(to.name)

  let nextRoute = {}
  const loggedIn = store.getters.loggedIn
  let activeUser = store.getters.getMyInfo
  let newUser = store.getters.newUser
  let users = store.getters.users
  let verifiedUser = activeUser && activeUser.emailVerified
  const unAuthorized = activeUser ? !activeUser.hasRoles : true

  if (!to.name) {
    nextRoute = { name: 'messages' }
  }
  if (!loggedIn && to.name === 'main') return next({ name: 'login' })
  if (loggedIn && to.name === 'main') return next({ name: 'accountManagement' })
  /* ##### USER IS NOT LOGGED IN BUT TRYING TO ACCESS PAGES REQUIRING A LOGIN ##### */
  if (loggedIn === false && (restrictedRoute === true && to.name !== 'resetPassword' && to.name !== 'forgotPassword')) {
    let loginRoute = {
      name: 'login'
    }

    if (to.name === 'unsubscribe') {
      loginRoute.query = {redirect: 'unsubscribe'}
    }

    return next(loginRoute)
  }

  // Redirect admin user to userManagement if logged in & trying to access signup / login
  if (loggedIn === true && (to.name === 'login' || to.name === 'signup')) {
    return next({ name: 'accountManagement' })
  }

  if (!restrictedRoute) return next()
  if (loggedIn && profileRoute) return next()

  if (loggedIn && !verifiedUser && unAuthorized && restrictedRoute) {
    // refresh myInfo just to be certain
    await store.dispatch('getMe')
    activeUser = store.getters.getMyInfo
    verifiedUser = activeUser && activeUser.emailVerified
    if (!activeUser || !verifiedUser) return next({name: 'verify'})
  }

  if (loggedIn && subscriptionRoute && store.getters.getActiveSubscription) return next()

  /* ##### USER IS LOGGED, IS NAVIGATING TO A NUTRITIONISTS PAGE BUT IS NOT AUTHORIZED TO DO SO ##### */
  if (loggedIn === true && authorizedRoute === true && unAuthorized === true) {
    nextRoute = { name: 'messages' }
    // Change to dashboard if reverting to other look

    /* ##### USER IS LOGGED AS A NUTRITIONIST WHO DOES NOT COMPLETE SURVEYS BUT TRYING TO ACCESS SURVEYS ##### */
  } else if (loggedIn === true && (surveyRoute === true || unRestrictedRoutes === true) && unAuthorized === false) {
    nextRoute = { name: 'messages' }
  } else if (loggedIn === true && restrictedRoute === false && to.name !== 'resetPassword' && to.name !== 'forgotPassword' && to.name !== 'terms') {
    nextRoute = { name: 'messages' }
    // Change to dashboard and skip following else-if, if reverting to other look
  } else if (loggedIn === true && to.name === 'dashboard') {
    nextRoute = { name: 'messages' }
  }

  if (loggedIn === true && (to.name === 'addParentGuardian' || to.name === 'addPayment')) {
    if (!newUser) {
      return next({name: 'addUser'})
    }
  }

  if (loggedIn === true && (to.name === 'bulkUploadReview' || to.name === 'bulkPayment')) {
    if (!users || users.length === 0) {
      return next({name: 'bulkUpload'})
    }
  }

  if (unAuthorized && adminAuthorizedRoute) {
    return next({name: 'accountManagement'})
  }

  try {
    next(nextRoute)
  } catch (err) {
    if (err) console.log(err)
  }
})
router.afterEach((to, from, next) => {
  const showSpinner = !(to.name === 'messages' && from.name === 'messageThread')
  if (to.name !== from.name && showSpinner) {
    store.dispatch('toggleSpinner', false)
  }
})
export default router



// WEBPACK FOOTER //
// ./src/router/index.js